<template>
  <div class="sso-callback">
    <div class="shadow-box pa-4 text-center">
      <img src="~@images/logo.svg" class="logo">

      <v-row v-if="loading">
        <v-col>
          <v-progress-circular indeterminate color="primary" size="48" class="my-6" />
          <p>{{ $t('sso.login-in-progress') }}</p>
        </v-col>
      </v-row>

      <v-row v-if="error">
        <v-col>
          <v-alert outlined class="my-10" type="error">{{ error }}</v-alert>
          <v-btn :to="{name: 'login'}" small text class="mt-2">
            {{ $t('login.login') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import SSORepository from "@repository/SSORepository";

export default {
  data() {
    return {
      loading: true,
      error: null,
    }
  },

  mounted() {
    this.handleCallback()
  },

  methods: {
    resolveError(errorCode) {
      if (errorCode && this.$te('sso.error.' + errorCode)) {
        return this.$t('sso.error.' + errorCode)
      }
      return errorCode || this.$t('sso.login-error')
    },

    handleCallback() {
      const params = new URLSearchParams(window.location.search)
      const error = params.get('error')
      const code = params.get('code')
      const state = params.get('state')
      const sso = params.get('sso')
      const returnUrl = params.get('return_url')

      // Error from IdP or backend redirect
      if (error) {
        this.loading = false
        this.error = this.resolveError(error)
        sessionStorage.removeItem('sso_state')
        sessionStorage.removeItem('sso_protocol')
        return
      }

      // SAML flow: cookies already set by backend in the 302 redirect
      if (sso === 'success') {
        sessionStorage.removeItem('sso_state')
        sessionStorage.removeItem('sso_protocol')
        this.$auth.setAuthenticated(true)
        this.$router.replace(returnUrl || { name: 'dashboard' })
        return
      }

      // OIDC flow: exchange code + state for cookies
      if (code && state) {
        const savedState = sessionStorage.getItem('sso_state')
        if (savedState && state !== savedState) {
          this.loading = false
          this.error = this.$t('sso.invalid-state')
          sessionStorage.removeItem('sso_state')
          sessionStorage.removeItem('sso_protocol')
          return
        }
        sessionStorage.removeItem('sso_state')
        sessionStorage.removeItem('sso_protocol')

        SSORepository.callback({ code, state }).then(() => {
          this.$auth.setAuthenticated(true)
          this.$router.replace(returnUrl || { name: 'dashboard' })
        }).catch(e => {
          this.loading = false
          const errorCode = e.response?.data?.error
          if (errorCode && this.$te('sso.error.' + errorCode)) {
            this.error = this.$t('sso.error.' + errorCode)
          } else {
            this.error = e.response?.data?.message || this.$t('sso.login-error')
          }
        })
        return
      }

      // No valid params
      this.loading = false
      this.error = this.$t('sso.login-error')
    },
  },
}
</script>

<style lang="scss" scoped>
.sso-callback {
  justify-content: center;
  .shadow-box {
    width: 40.404vw;
    min-width: 400px;
    @media only screen and (max-width: 600px) {
      width: 100%;
      min-width: 100%;
    }
    .logo {
      width: 23.232vw;
      @media only screen and (max-width: 600px) {
        width: 80%;
      }
    }
  }
}
</style>
